import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {FormGroup, FormControl, Validators} from '@angular/forms';

@Component({
  selector: 'app-right-ebs-panel',
  templateUrl: './right-ebs-panel.component.html',
  styleUrls: ['./right-ebs-panel.component.scss']
})
export class RightEbsPanelComponent implements OnInit {
  @Input() ebs;
  @Output() closePanelEvent = new EventEmitter<void>();
  @Output() saveEbsEvent = new EventEmitter<void>();
  @Output() deleteEbsEvent = new EventEmitter<void>();

  ebsForm: FormGroup;

  ngOnInit() {
    this.ebsForm = new FormGroup({
      SN: new FormControl(this.ebs.value.SN || '', [
        Validators.minLength(4),
        Validators.maxLength(15),
        Validators.pattern('^(0|[1-9][0-9]*)$'),
        Validators.required
      ]),
      name: new FormControl(this.ebs.value.name  || '', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(64),
        Validators.pattern('^[a-zA-Z]{3,10}$')
      ]),
      phoneNum: new FormControl(this.ebs.value.phoneNum  || '', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(15),
        Validators.pattern('([0-9]*)$')
      ])
    });
  }

  closePanel() {
    this.closePanelEvent.emit();
  }

  saveTempMac() {
    if (this.ebsForm.valid) {
      this.saveEbsEvent.emit(this.ebsForm.value);
    } else {
      // Oznacz wszystkie pola jako "touched", żeby app-validate-errors
      // (które pokazują się tylko dla dotkniętych pól) wyświetliły komunikaty.
      this.ebsForm.markAllAsTouched();
    }
  }

  deleteTempMac() {
    this.deleteEbsEvent.emit();
  }
}
